import customFetch from "../util/config/axiosConfig";
import {
  GenerateOtpRequest,
  GenerateOtpResponse,
  LoginRequest,
  PasswordLoginResponse,
  verifyOtpRequest,
  VerifyOtpResponse,
} from "../types/authTypes";
import { ApiResponse } from "../types/responseType";
import { getLocalStorage, getUserFromStorage } from "../util/manageStorage";
import { Staff } from "../types/staff";
import { toast } from "sonner";
import { getErrorMessage } from "../util/functions/UniversalFunctions";

const authApis = {
  // ✅ Password Login
  passwordLogin: async (
    user: LoginRequest,
  ): Promise<ApiResponse<PasswordLoginResponse> | undefined> => {
    const response = await customFetch.post("/api/auth/admin/login", {
      emailOrMobile: user.emailOrMobile,
      password: user.password,
    });
    return response.data;
  },

  // ✅ Generate OTP
  generateOtp: async (
    data: GenerateOtpRequest,
  ): Promise<ApiResponse<GenerateOtpResponse> | undefined> => {
    try {
      const response = await customFetch.post("/api/auth/generate-otp", {
        phoneNo: data.phoneNo,
      });
      return response.data;
    } catch (error) {
      console.error("Error in generateOtp:", error);
    }
  },

  // ✅ Verify OTP
  verifyOtp: async (
    data: verifyOtpRequest,
  ): Promise<ApiResponse<VerifyOtpResponse> | undefined> => {
    try {
      const response = await customFetch.post("/api/auth/verify-otp", data, {
        headers: {
          Authorization: `Bearer ${getLocalStorage("user")?.accessToken ?? ""}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error in verifyOtp:", error);
    }
  },

  //EMP_CODE
  getStaffByEmpCode: async (
    empCode: string,
  ): Promise<ApiResponse<Staff[]> | undefined> => {
    try {
      const response = await customFetch.get(
        `/api/auth/staffs-by-emp-code/${empCode}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error in getStaffByEmpCode:", error);
    }
  },

  //change_password
  changePassword: async (data: {
    userId?: number;
    oldPassword?: string;
    newPassword: string;
  }): Promise<ApiResponse<PasswordLoginResponse> | undefined> => {
    const response = await customFetch.patch("/api/auth/update-password", {
      userId: data?.userId ?? getUserFromStorage()?.userId,
      oldPassword: data.oldPassword,
      newPassword: data?.newPassword,
    });
    return response.data;
  },

  // staff login
  staffLogin: async (data: {
    staffId: number;
    password: string;
  }): Promise<ApiResponse<PasswordLoginResponse> | undefined> => {
    const response = await customFetch.post("/api/auth/staff/login", {
      staffId: data.staffId,
      password: data.password,
    });
    return response.data;
  },

  deleteAccount: async (
    mobileOrEmail: string,
  ): Promise<ApiResponse<null> | undefined> => {
    try {
      const response = await customFetch.delete<ApiResponse<null>>(
        `/api/auth/delete-account`,
        {
          params: {
            mobileOrEmail,
          },
        },
      );

      toast.success("Account deleted successfully");
      return response.data;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error?.message ||
          getErrorMessage(error) ||
          "Failed to delete account",
      );

      console.error("Delete account error:", error);
      throw error;
    }
  },
};

export default authApis;
